import * as React from 'react'

import Page from 'main/components/common/Page'
import Benefits from './Benefits'
import Footer from './Footer'
import Intro from './Intro'

export default class MobileApp extends React.Component<{}> {
  public render() {
    return (
      <Page>
        <Intro />
        <Benefits />
        <Footer />
      </Page>
    )
  }
}
